export default __webpack_public_path__ + "static/media/Snd_CK.abe6dbcd.mp3";